import httpRequest from '@/utils/httpRequest'

// 添加订单修改日志
export const addV = (sourceId,messageContent) => {
    //if (!sourceId) {return}
    //if (!messageContent) {return;}
    //httpRequest({
    //    url: httpRequest.adornUrl(`/oder_info_update_log`),
    //    method: 'POST',
    //    data: httpRequest.adornData({ sourceId: sourceId, messageContent: messageContent }),
    //}).then(({data}) => {})
}
